var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledCheckCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    fill: "#8BE3CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1104 15.3896L7.00081 12.28L5.94189 13.3315L10.1104 17.5L19.059 8.55145L18.0075 7.5L10.1104 15.3896Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledCheckCircleIcon);
export default __webpack_public_path__ + "static/media/filled-check-circle-icon.f1ea84a8f32d2c067daab5d7aa65b5fd.svg";
export { ForwardRef as ReactComponent };